// extracted by mini-css-extract-plugin
export default {"overlay":"ThresholdModal-module__overlay__boKqs","dialog-content":"ThresholdModal-module__dialog-content__wzqyQ"};